import React from 'react';
import CensusSection from '../Common/CensusSection';
import ThemeMap from '../Theme/ThemeMap';

const Households = () => (
    <CensusSection
        menuPath="households"
        pages={[
            { path: 'households-1', title: 'Domicílios 1', element: <ThemeMap theme="domicilio_1" /> },
            { path: 'households-2', title: 'Domicílios 2', element: <ThemeMap theme="domicilio_2" /> },
            { path: 'households-3', title: 'Domicílios 3', element: <ThemeMap theme="domicilio_3" /> }
        ]}
    />
);

export default Households;
